module.exports = __webpack_public_path__ + "static/media/elo_hero_desktop.7b6a6e6e.webp";